import { symbolKey } from '@/entities/symbol/symbolKey';
import type { SymbolKey } from '@/entities/symbol/types';

export function getUniqueSymbols(symbols: SymbolKey[], isForwardMode = false): SymbolKey[] {
  const seen = new Set<string>();
  const out: SymbolKey[] = [];
  for (const s of symbols) {
    const k = symbolKey(s, isForwardMode);
    if (!seen.has(k)) {
      seen.add(k);
      out.push(s);
    }
  }
  return out;
}
